/*
 *  Loader.tsx
 * This Component is used to manage loader commonly.
 */
import styles from "./loader.module.css";
import { Loading3QuartersOutlined} from "@ant-design/icons";

type TLoader = {
  size?: any;
};
export default function Loader(props: TLoader) {
  const { size } = props;
  return (
    <div className={styles.loaderContainer}>
      <Loading3QuartersOutlined
        className={styles.spin}
        spin
        style={{ fontSize: size }}
      />
    </div>
  );
}
